import { commonAxios } from "../utils/AxiosSettings";
export async function getAllFactoriesOfCompany(company, token, operation) {
    let queryUrl = new URL(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/factories/?Company=${company}`
    );
    operation && queryUrl.searchParams.append("operation", operation);
    const res = await commonAxios.get(queryUrl);
    return res;
}
export async function getFactoryDataByID(factory) {
    const res = commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/factory/${factory}`
    );

    return res;
}
export async function getFactorydetails(factory) {
    const res = commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/factorydetails/?factory=${factory}`
    );

    return res;
}

export const fetchTimeZones = async () => {
    const { data } = await commonAxios.get(
        `${process.env.REACT_APP_BASE_URL_API}/api/accounts/timezonelist/`
    );

    return data;
};
